import { createFileRoute } from "@tanstack/react-router";

import { programGridZoomSearchSchema } from "src/contexts/ProgramGridZoomContext";
import {
  calendarSearchSchema,
  getCalendarInitialView,
} from "src/lib/calendarViewRoute";
import { loaderHandler } from "src/lib/loaderHandler";
import { CoachAthleteCalendarPage } from "src/pages/CoachAthleteCalendarPage";
import {
  fetchCalendarInitialData,
  getAthleteCalendarSource,
} from "src/queries/calendar";
import { fetchCalendarInitialPhases } from "src/queries/calendarPhases";

export const Route = createFileRoute(
  "/_auth/_coach/athletes/$athleteId/_tabs/calendar/",
)({
  component: RouteComponent,
  ssr: true,
  staticData: {
    getScrollRestoration: () => {
      return false;
    },
  },
  validateSearch: calendarSearchSchema.extend({
    zoom: programGridZoomSearchSchema,
  }),
  loaderDeps: (args) => {
    return { view: args.search.view };
  },
  async loader({ context, params, location }) {
    return await loaderHandler(async () => {
      const calendar = getCalendarInitialView(location.href, "measured");
      const [initialData] = await Promise.all([
        fetchCalendarInitialData(
          getAthleteCalendarSource(params.athleteId, calendar),
          calendar,
        ),
        fetchCalendarInitialPhases(
          context.queryClient,
          params.athleteId,
          calendar,
        ),
      ]);

      return { data: { calendar, initialData } };
    });
  },
});

function RouteComponent() {
  const loaderData = Route.useLoaderData();
  return (
    <CoachAthleteCalendarPage
      calendar={loaderData.data.calendar}
      initialData={loaderData.data.initialData}
    />
  );
}
